import { render, staticRenderFns } from "./ContactsFormModal.vue?vue&type=template&id=40f86b03&scoped=true&"
import script from "./ContactsFormModal.vue?vue&type=script&lang=js&"
export * from "./ContactsFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f86b03",
  null
  
)

export default component.exports